//Copied from crystal.js
//Special Campaign Source Codes:
export var campaign = {
    Nerd_Purch: 6340524,
    Nerd_Purch_All: [6340524, // default
        11105454, 11105472, 11105508, 11105533, // Excellent, Good, Fair, Poor 
        13372616, 13372586, 13372567, 13372551, // Excellent, Good, Fair, Poor + TimeFrame:GOOD2GO
        14468988, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - VA
        14468942, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - VA
        14469096, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - VA
        14469109, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - VA
        14469261, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - Jumbo
        14469247, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - Jumbo
        14469278, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - Jumbo
        14469290], //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - Jumbo
    Adwords_Purch: 10498546,
    Adwords_Refi: 10498520,
    TV_Atlanta: 5661538,
    //         //Purch  //Refi
    Nerd_All: [7101456, 7101464, //Nerdwallet        :: Nerdwallet-Ratetable-Pur/Refi
        6340524, 6340509, //NerdWallet        :: Nerdwallet - Pur/Refi
        11105454, //NerdWallet        :: Nerdwallet - Pur - EX/720+-YYMM
        11105472, //NerdWallet        :: Nerdwallet - Pur - GD/680-719-YYMM
        11105508, //NerdWallet        :: Nerdwallet - Pur - Fair/620-679-YYMM
        11105533, //NerdWallet        :: Nerdwallet - Pur - Poor/619--YYMM
        13372616, //NerdWallet        :: Nerdwallet - Pur - EX/720+ (GOOD2GO)
        13372586, //NerdWallet        :: Nerdwallet - Pur - GD/680-719 (GOOD2GO)
        13372567, //NerdWallet        :: Nerdwallet - Pur - Fair/620-679 (GOOD2GO)
        13372551, //NerdWallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO)
        14468988, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - VA
        14468942, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - VA
        14469096, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - VA
        14469109, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - VA
        14469261, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ (GOOD2GO) - Jumbo
        14469247, //Nerdwallet        :: Nerdwallet - Pur - Poor/619- (GOOD2GO) - Jumbo
        14469278, //Nerdwallet        :: Nerdwallet - Pur - Fair/GD/EX/620+ - Jumbo
        14469290] //Nerdwallet        :: Nerdwallet - Pur - Poor/619- - Jumbo
    //,CA_ALL: [11207699, 11207716,    //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_NA_Pros_US_Affiliate_2spot_Pur/Refi
    //           10949559, 10949579,  //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_Refinance_NA_Pros_US_Affiliate_Pur/Refi
    //           10607314,10606642,   //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_HELOC_NA_Pros_US_Affiliate_Pur/Refi
    //           9422065, 9422078]    //ConsumersAdvocate :: Consumersadvocate.org_NonBrand_NA_Pros_US_Affiliate_Pur/Refi
};
